import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ITopicFormInput, ITopicUpdateProps } from "./Topic.model";
import { TopicService } from "../../service/Topic/topic.service";
import TopicForm from "./_topicForm";

const TopicUpdate = ({
  data,
  setTopicDialog,
  loadTopics,
}: ITopicUpdateProps) => {
  const [id, setId] = useState<number | null>(null);

  const methods = useForm<ITopicFormInput>({
    mode: "onSubmit",
    defaultValues: {
      name: "",
      description: "",
      is_active: true,
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        name: data.name,
        description: data.description || "",
        is_active: data.is_active,
      });
    }
  }, [data]);

  const onSubmit = async (values: ITopicFormInput) => {
    if (!id) return;

    const response = await TopicService.update(id, values);

    if (response.success) {
      loadTopics();
      setTopicDialog(false);
    } else {
      Object.keys(response.errors || {}).forEach((field) => {
        methods.setError(field as any, {
          type: "manual",
          message: response.errors[field],
        });
      });
    }
  };

  return <TopicForm methods={methods} onSubmit={onSubmit} isEdit={true} />;
};

export default TopicUpdate;
